import React from 'react';
const TagMultiValueContainer = ({ children }) => (React.createElement("div", { className: "flex items-center border border-blue-10 hover:border-blue-40 transition-colors rounded-lg bg-blue-0 gap-2 py-1 pl-3 pr-2 cursor-default" }, children));
export default TagMultiValueContainer;
